import "core-js/stable";
import "regenerator-runtime/runtime";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import { toggleBodyClass } from './_class/_toggle';

document.querySelector('.menu-icon').addEventListener('click', toggleBodyClass('menu-open'));
document.querySelector('.menu-close').addEventListener('click', toggleBodyClass('menu-open'));

import './home/_slider.js';

document.body.addEventListener('click', (e) =>{
  if(document.location.search !== '?debug') return;
  const name = 'show-grid';
  if(e.target.classList.contains(name)){
    return e.target.classList.remove(name);
  }
  document.querySelectorAll(`.${name}`).forEach((item, i) => {
    item.classList.remove(name)
  });
  return e.target.classList.add(name);
});
